import { render, staticRenderFns } from "./ChartMain.vue?vue&type=template&id=6be47e0d"
import script from "./ChartMain.vue?vue&type=script&lang=js"
export * from "./ChartMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports